import { ETemplateType } from "../../redux/template/template.types";
export var ENTITY = "template document";
export var REDUCER_KEY = "TEMPLATE_DOCUMENTS_V2";
export var BASE_PATH_ENTITY = "template-documents";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    defaultSort: [{ field: "createdAt", method: "DESC" }],
};
// The template types that represent a rental contract. The v1 API selected these with a
// case-insensitive `like "%contract%"` on the type column; on v2 they are matched explicitly.
export var CONTRACT_TEMPLATE_TYPES = [
    ETemplateType.ContractResidential,
    ETemplateType.ContractResidentialShort,
    ETemplateType.ContractResidentialLong,
    ETemplateType.ContractStudentResidence,
    ETemplateType.ContractCommercial,
    ETemplateType.ContractParkingLot,
    ETemplateType.ContractGarage,
    ETemplateType.ContractOther,
];
